import styled, { css } from 'styled-components';
import {
  ClearFix,
  Flex,
  GridContent,
  mediaMixin,
  PageBreadcrumb,
  PageContent,
  Table,
  token,
} from '@zillow/constellation';

import BannerBackgroundImage from '../../images/tenantPlacement/tenant-placement-hero-image-desktop.svg';
import BannerBackgroundImageTablet from '../../images/tenantPlacement/tenant-placement-hero-image-tablet.svg';
import BannerBackgroundImageMweb from '../../images/tenantPlacement/tenant-placement-hero-image-mobile.svg';

const getBannerImageWidthXXLGTE = ({ isLayoutHorizontal = false }: { isLayoutHorizontal: boolean }) => {
  return css`
    width: ${isLayoutHorizontal ? '100%' : '1512px'};
  `;
};

export const StyledIntroBannerContainer = styled.div`
  position: relative;
  background-color: white;
`;

export const StyledBannerImageDiv = styled.div<{ isLayoutHorizontal?: boolean }>`
  margin: auto;
  background-size: cover;

  ${mediaMixin(
    'xxl_gte',
    css`
      background-image: url(${BannerBackgroundImage});
      width: ${getBannerImageWidthXXLGTE};
      height: 435px;
      background-position-x: center;
      background-repeat: no-repeat;
    `,
  )}

  ${mediaMixin(
    'xl_lte',
    css`
      background-image: url(${BannerBackgroundImageTablet});
      height: 455px;
    `,
  )}

  ${mediaMixin(
    'sm_lte',
    css`
      background-image: url(${BannerBackgroundImageMweb});
      height: 460px;
    `,
  )}
`;

export const StyledFullBleedWhiteBackground = styled(ClearFix)`
  background-color: ${token('colors.white')};
`;

export const StyledMainBodyPageContent = styled(PageContent)`
  max-width: 892px;
  margin-top: 54px;
`;

export const StyledHidden = styled.div`
  ${(props: { breakpoint: string }) => {
    return mediaMixin(
      props.breakpoint,
      css`
        display: none;
      `,
    );
  }}
`;

export const StyledGridSection = styled(GridContent)`
  border: 1px solid ${token('colors.gray300')};
  ${mediaMixin(
    'sm_lte',
    css`
      border: none;
    `,
  )}
`;

export const StyledTableHeaderCell = styled(Table.HeaderCell)`
  &&& {
    vertical-align: middle;
  }
`;

export const StyledHighlightedTableHeaderCell = styled(Table.HeaderCell)`
  &&& {
    background-color: ${token('colors.backgroundBlue')};
    vertical-align: middle;
  }
`;

export const StyledCenteredHeaderCell = styled(Table.HeaderCell)`
  &&& {
    vertical-align: middle;
  }
`;

export const StyledHighlightedTableCell = styled(Table.Cell)`
  &&& {
    background-color: ${token('colors.backgroundBlue')};
    vertical-align: middle;
  }
`;

export const StyledCenteredTableCell = styled(Table.Cell)`
  &&& {
    vertical-align: middle;
  }
`;

export const StyledIntroBannerTextContainer = styled.div`
  position: absolute;
  top: 0;
  max-width: 892px;
  height: 100%;
`;

export const StyledWhitePageBreadcrumb = styled(PageBreadcrumb)`
  button {
    color: ${token('colors.white')};
  }
`;

export const StyledBannerFlex = styled(Flex)`
  height: 100%;
  width: 100%;
  margin-top: 24px;

  ${(props) =>
    mediaMixin(
      'md_gte',
      css`
        margin-top: ${props.needsBackButtonPadding ? '64px;' : '80px'};
      `,
    )}
  ${(props) =>
    mediaMixin(
      'xxl',
      css`
        margin-top: ${props.needsBackButtonPadding ? '24px;' : '64px'};
      `,
    )}
`;

export const StyledTransparentGridContent = styled(GridContent)`
  background: transparent;
`;

export const StyledDoorsteadContainer = styled(Flex)`
  background-color: ${token('colors.gray200')};
  width: 100%;
`;
export const StyledDoorsteadContent = styled(GridContent)`
  background: transparent;
`;
export const StyledDoorsteadFlex = styled(Flex)`
  max-width: 892px;
`;
